import { RouteObject } from 'react-router-dom';
import { SideMenuLayout } from 'components/layouts';
import { appPaths } from 'consts/paths/paths';
import { AbilityRoute } from 'navigation/AbilityRoute/AbilityRoute';
import { AppActions } from 'types';
import { PERMISSIONS_NAME } from 'consts/permissions/permissions';
import {
    EmailConfirmationRequiredInfo,
    InstitutionAddPage,
    InstitutionDetailsEditPage,
} from 'pages';
import { accountRoutes } from './staff/account';

export const unverifiedStaffRoutes: RouteObject[] = [
    {
        element: <SideMenuLayout />,
        children: [
            ...accountRoutes,
            {
                path: appPaths.app['add-institution'],
                element: (
                    <AbilityRoute
                        can={{
                            action: AppActions.DO_ACTION,
                            subject: PERMISSIONS_NAME.INSTITUTIONS_CREATE,
                        }}
                    >
                        <InstitutionAddPage />
                    </AbilityRoute>
                ),
            },
            {
                path: appPaths.app.settings['institution-details'].edit,
                element: (
                    <AbilityRoute
                        can={{
                            action: AppActions.EDIT_AND_ADD,
                            subject: PERMISSIONS_NAME.INSTITUTION_DATA,
                        }}
                    >
                        <InstitutionDetailsEditPage />
                    </AbilityRoute>
                ),
            },
        ],
    },
    {
        path: appPaths.app['user-confirmation'],
        element: <EmailConfirmationRequiredInfo />,
    },
];
